import { Trans } from '@lingui/macro';
import { BOOKING_TYPE, TireHotelContractItem } from 'noddi-types';
import { NoddiButton, NoddiDummyButton } from 'noddi-ui-common';
import { NoddiBasicCard } from 'noddi-ui-web';
import { customerRoutes } from 'noddi-util';
import { useNavigate } from 'react-router-dom';
import { useBookingActions } from '../BookingFlow/bookingStore';
import TireHotelSvg from './TireHotelSvg';

type ContractCardProps = {
  tireHotelContract: TireHotelContractItem;
};

export const ContractCard = ({ tireHotelContract }: ContractCardProps) => {
  const navigate = useNavigate();

  const { clearStore, addCar, setBookingType } = useBookingActions();

  const {
    bookingItemSalesItem,
    car: { make, model, licensePlate },
    canRenewContract
  } = tireHotelContract;

  const prePopulateAndNavigate = ({ isCancel }: { isCancel: boolean }) => {
    clearStore();
    addCar({
      make,
      model,
      hasActiveTireHotelContract: true,
      licensePlate
    });

    if (isCancel) {
      setBookingType(BOOKING_TYPE.CANCEL_TIER_HOTEL);
    }
    navigate(customerRoutes.newBookingAddress.getPath());
  };

  // When its a new TH booking, or renewal / cancel is ordered
  const showBookingLink = bookingItemSalesItem?.bookingId && !canRenewContract;

  return (
    <NoddiBasicCard
      to={showBookingLink ? customerRoutes.myBookingDetails.getPath({ id: bookingItemSalesItem.bookingId }) : undefined}
      className='flex flex-col gap-4'
    >
      <div className='flex justify-between gap-6'>
        <div>
          <p className='font-bold text-5'>{`${make} ${model}`}</p>
          <p className='text-5'>{licensePlate.number}</p>
        </div>
        <div>
          <TireHotelSvg />
        </div>
      </div>

      {canRenewContract && (
        <div className='flex gap-4'>
          <NoddiButton
            className='flex-1'
            variant='secondary'
            size='small'
            onPress={(e) => {
              e.stopPropagation();
              prePopulateAndNavigate({ isCancel: true });
            }}
          >
            <Trans>End agreement</Trans>
          </NoddiButton>
          <NoddiButton
            className='flex-1'
            size='small'
            onPress={(e) => {
              e.stopPropagation();
              prePopulateAndNavigate({ isCancel: false });
            }}
          >
            <Trans>Order wheel change</Trans>
          </NoddiButton>
        </div>
      )}
      {showBookingLink && (
        <div className='flex justify-end'>
          <NoddiDummyButton className='-mb-2 -mr-4' variant='link' endIcon='ArrowRight'>
            <Trans>See booking</Trans>
          </NoddiDummyButton>
        </div>
      )}
    </NoddiBasicCard>
  );
};
